import React, { useState } from 'react'
import { Email } from '@smastrom/react-email-autocomplete'
import { emailRegex } from '@/lib/regex'
import { TextItemInterface } from '@/types/newTypes'
import clsx from 'clsx'
import SecurityAndPrivacy from './screens/SecurityAndPrivacy'
import TryButtonBrand from './screens/brand/TryButtonBrand'
import TryButton from './screens/TryButton'
import { Link, useNavigate } from 'react-router-dom'
import { trackEmail, trackLead } from '@/helpers/facebookPixelEvents'
import { useTheme } from './ThemeProvider'
import { getRegionUrl } from '@/helpers/getCountryCode'

export const EmailForm = ({ version }: { version?: string }) => {
  const navigate = useNavigate()
  const [email, setEmail] = useState<string>('')
  const [isValid, setIsValid] = useState<boolean>(true)
  const { theme } = useTheme()

  const region = localStorage.getItem('region') || 'US'
  const privacyPolicyRoute = getRegionUrl(region, 'privacy-policy')
  const termsRoute = getRegionUrl(region, 'terms-of-use')

  const handleEmailChange = (value: string) => {
    setEmail(value)
    setIsValid(emailRegex.test(value))
  }

  const handleAddEndingByButton = (value: string) => {
    const newValue = email.split('@')[0] + value
    setEmail(newValue)
    setIsValid(emailRegex.test(newValue))
  }

  const baseList = [
    'gmail.com',
    'hotmail.com',
    'yahoo.com',
    'outlook.com',
    'aol.com',
    'icloud.com',
    'live.com',
    'msn.com',
    'me.com',
    'mac.com',
    'googlemail.com',
    'facebook.com',
    'verizon.net',
    'rediffmail.com',
    'zohomail.com',
    'zoho.com',
    'mail.com',
    'google.com',
    'comcast.com',
    'hotmail.co.uk',
    'yahoo.co.uk',
    'att.net',
    'gmz.com',
  ]

  const buttons: TextItemInterface[] = [
    {
      text: '@gmail.com',
    },
    {
      text: '@yahoo.com',
    },
    {
      text: '@hotmail.com',
    },
  ]

  const handleSubmit = () => {
    localStorage.setItem('userEmail', email)
    trackLead()
    trackEmail('Mail_completed', email)
    navigate(version ? '/new/paywall' : '/paywall')
  }

  return version ? (
    <section className="p-2 relative min-h-screen">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-screen max-w-[430px]">
        <img
          className="w-full"
          src={`/img/email/circle${theme === 'light' ? '-light' : ''}.svg`}
          alt="image"
        />
      </div>
      <div
        className={`max-w-[430px] shadow-[0px 4px 4px 0px #00000033] email-section  shadow-hero dark:before:hidden dark:shadow-none before:absolute before:content-['']  before:-top-[75px] before:w-full before:left-0 before:h-[75px] before:bg-[#D4D9FF]  relative z-10 w-screen -ml-6 px-6 rounded-b-5xl pb-6 ${theme === 'light' ? 'bg-bgEmailGradient' : ' bg-bg'}`}
      >
        <div className="max-w-full border border-[#3947E6] dark:before:!block before:hidden z-10 mx-auto mb-6 text-center flex flex-col gap-1 rounded-2xl  relative before:backdrop-blur-[24px] before:absolute  before:content-[''] before:-left-px before:-right-px before:-top-px before:-bottom-px before:z-[-1]  before:bg-borgerLightGradient before:rounded-2xl  text-[14px] font-semibold  ">
          <div className="dark:bg-bg dark:bg-orangeToYellowGradientDark rounded-2xl bg-[#FBFBFBA3] p-2">
            <img
              className={'max-w-[100px] mx-auto'}
              src={`/img/email/star-new${theme === 'light' ? '-blue' : ''}.svg`}
              alt="image"
            />
            <span>5+ million users have trusted us</span>
          </div>
        </div>
        <h2 className="mb-3 text-center text-LXL2 font-semibold">
          Enter your email to start freeing up space!
        </h2>
        <h3 className="text-[#1D2BDB] dark:text-lightText text-center text-logo">
          We’ll create an account for you to manage
          <br />
          your cleanup process
        </h3>

        <div className="email-input-container pt-8" data-valid={isValid ? 'true' : 'false'}>
          <Email
            baseList={baseList}
            onChange={handleEmailChange}
            value={email}
            placeholder="E-mail"
            refineList={baseList}
          />
        </div>
        <div className="grid grid-cols-3 gap-2 mb-6">
          {buttons.map((item, index) => (
            <button
              key={index}
              type="button"
              onClick={() => handleAddEndingByButton(item.text)}
              disabled={email.length === 0}
              className={clsx(
                'h-[36px] py-2 px-1 text-[12px] bg-[#FBFBFB] border-[#A9B2FF]  text-[#A9B2FF] font-normal rounded-xl border dark:text-[#6E6E70] dark:bg-[#1A1A1D] dark:border-[#373738] disabled:cursor-default',
              )}
            >
              {item.text}
            </button>
          ))}
        </div>
        <div>
          <TryButtonBrand
            text="Continue"
            disabled={!isValid || email.length === 0}
            onClick={() => handleSubmit()}
            large={true}
          />
        </div>
      </div>
      <div className="text-center relative gap-4 z-10 mt-4 grid grid-cols-2 -mx-2">
        <div className='flex dark:before:!block before:hidden dark:border-none border border-[#5E6CFF] dark:p-px  dark:text-[#FBFBFB] text-[12px]  rounded-2xl relative before:backdrop-blur-[24px] before:absolute  before:content-[""] before:left-0 before:right-0 before:top-0 before:bottom-0 before:z-[-1]  before:bg-borgerColorGradient before:rounded-2xl'>
          <div className="flex w-full items-center p-2 rounded-2xl bg-[#FBFBFBA3] dark:bg-[#493787] justify-center">
            <p>100% Private & Secure</p>
          </div>
        </div>
        <div className='flex  dark:p-px dark:before:!block before:hidden dark:border-none border border-[#5E6CFF]  dark:text-[#FBFBFB] text-[12px] rounded-2xl  relative before:backdrop-blur-[24px] before:absolute  before:content-[""] before:left-0 before:right-0 before:top-0 before:bottom-0 before:z-[-1]  before:bg-borgerColorGradient before:rounded-2xl'>
          <div className="flex w-full items-center p-2 rounded-2xl bg-[#FBFBFBA3] dark:bg-[#493787] justify-center">
            <p>Advanced Encryption for Photo Safety</p>
          </div>
        </div>
      </div>
      <p className="mb-12 mt-[10px] relative text-center text-[#7f7f7f] text-[11px]">
        By continuing, I agree to the{' '}
        <Link className="underline" to={{ pathname: termsRoute }}>
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link className="underline" to={{ pathname: privacyPolicyRoute }}>
          Privacy Policy
        </Link>
      </p>
    </section>
  ) : (
    <section className="py-8 sm:px-4">
      <div className="max-w-[305px] mx-auto mb-6 flex gap-2 rounded-xs py-2 px-4 bg-orangeToYellowGradientDark dark:bg-orangeToYellowGradient text-SM2 font-semibold tracking-[0.5px] uppercase">
        <svg viewBox="0 0 16 16" width={16}>
          <use href="/svg/sprite.svg#star"></use>
        </svg>
        <span>5+ million users have trusted us</span>
      </div>
      <h2 className="mb-2 text-center text-XL font-bold">
        Enter your email to start freeing up space!
      </h2>
      <h3 className="mb-6 text-white/70 text-center text-logo">
        We’ll create an account for you to manage
        <br />
        your cleanup process
      </h3>

      <div className="email-input-container" data-valid={isValid ? 'true' : 'false'}>
        <Email
          baseList={baseList}
          onChange={handleEmailChange}
          value={email}
          placeholder="Email"
          refineList={baseList}
        />
      </div>
      <div className="flex gap-2.5 mb-10">
        {buttons.map((item, index) => (
          <button
            key={index}
            type="button"
            onClick={() => handleAddEndingByButton(item.text)}
            disabled={email.length === 0}
            className={clsx(
              'h-[34px] py-2 px-2.5 text-SM2 font-normal rounded-2xl border text-graySecondary dark:border-graySecondary disabled:cursor-default',
            )}
          >
            {item.text}
          </button>
        ))}
      </div>
      <div className="mb-6">
        <TryButton
          text="Continue"
          disabled={!isValid || email.length === 0}
          onClick={() => handleSubmit()}
        />
      </div>
      <SecurityAndPrivacy secondary />
      <p className="mb-12 mt-[-20px] text-center text-[#7f7f7f] text-[11px]">
        By continuing, I agree to the{' '}
        <Link className="underline" to={{ pathname: termsRoute }}>
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link className="underline" to={{ pathname: privacyPolicyRoute }}>
          Privacy Policy
        </Link>
      </p>
    </section>
  )
}
